import React from 'react';
import { Form } from 'react-bootstrap';
import { useFormContext } from 'react-hook-form';
import { ResourceRequestFormFields } from '../utils/ResourceRequestTypes';

interface RESLCustomFieldsProps {
  isCompleted: boolean;
  isReadOnly?: boolean;
  hasApprovalAuthority?: boolean;
}

export const RESLCustomFields: React.FC<RESLCustomFieldsProps> = ({
  isCompleted,
  isReadOnly = false,
  hasApprovalAuthority = true,
}) => {
  const { watch, setValue } = useFormContext<ResourceRequestFormFields>();

  return (
    <>
      <div className="mb-3">
        <label className="form-label">
          Check Box (a) if request is for tactical resources or personnel
        </label>
        <div>
          <Form.Check
            type="checkbox"
            label="Tactical"
            checked={watch('resl_tac') || false}
            onChange={
              isReadOnly || !hasApprovalAuthority
                ? undefined
                : (e) => setValue('resl_tac', e.target.checked)
            }
            disabled={isCompleted || isReadOnly || !hasApprovalAuthority}
          />
          <Form.Check
            type="checkbox"
            label="Personnel"
            checked={watch('resl_personnel') || false}
            onChange={
              isReadOnly || !hasApprovalAuthority
                ? undefined
                : (e) => setValue('resl_personnel', e.target.checked)
            }
            disabled={isCompleted || isReadOnly || !hasApprovalAuthority}
          />
        </div>
      </div>
      <div className="mb-3">
        <label className="form-label">Resource Status</label>
        <div>
          <Form.Check
            type="radio"
            name="resl_available"
            label="b. Available"
            checked={watch('resl_available') === true}
            onChange={
              isReadOnly ? undefined : () => setValue('resl_available', true)
            }
            disabled={isCompleted || isReadOnly || !hasApprovalAuthority}
          />
          <Form.Check
            type="radio"
            name="resl_available"
            label="c. Not available"
            checked={watch('resl_available') === false}
            onChange={
              isReadOnly ? undefined : () => setValue('resl_available', false)
            }
            disabled={isCompleted || isReadOnly || !hasApprovalAuthority}
          />
        </div>
      </div>
    </>
  );
};
